import { EXERCISE_DURATION_UNIT } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RightViewTerm(_ref) {
  let {
    right
  } = _ref;
  if (!right) return null;
  const [label, text] = rightViewTerm(right);
  if (!label) return null;
  return /*#__PURE__*/_jsxs("span", {
    className: styles.rightViewLimit,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.label,
      children: label
    }), /*#__PURE__*/_jsx("span", {
      children: text
    })]
  });
}
export function rightViewTerm(right) {
  if (right !== null && right !== void 0 && right.exercise_term) {
    var _EXERCISE_DURATION_UN;
    return ["視聴可能期間", `視聴開始後${right.exercise_term}${(_EXERCISE_DURATION_UN = EXERCISE_DURATION_UNIT[right === null || right === void 0 ? void 0 : right.exercise_term_unit]) === null || _EXERCISE_DURATION_UN === void 0 ? void 0 : _EXERCISE_DURATION_UN.label}`];
  } else if (right !== null && right !== void 0 && right.view_limit_date) {
    return ["視聴期間", `決済日から${right.view_limit_date}まで`];
  }
  return [];
}